export const APPEARANCE_FONTS: string[] = ['Lobster', 'Courgette', 'Parisienne', 'Open Sans'];
export const APPEARANCE_SUPPORTED_EXTENSIONS: string[] = ['png', 'jpg', 'jpeg', 'bmp', 'gif'];
